import React, { useState, useRef } from 'react';
import { supabase } from '../supabaseClient';
import GosterGizle from './GosterGizle';
import { uploadErrorMessage } from './uploadErrorText';
import { usePencereKapat, KapatX } from './pencereKapat';   // pencere kapatma tek tip — ESC + ✕ (12 Eki 2026)

// ─── Upload Modal ─────────────────────────────────────────────────────────────
// `export`: hata metinlerinin EKRANDA fiilen ciktigi render testi icin
// (uploadErrorText.test.js saf kurali, UploadPlanModal.test.js ekrani surer).
function UploadPlanModal({ onClose, onUploaded }) {
  const [loading, setLoading] = useState(false);
  // HATA IKI PARCADIR (30 Agu 2026): ekranda INSAN CUMLESI, teknik metin
  // katlanmis "technical detail"de. Serkan: *"error kod vermesin."*
  const [error, setError]     = useState(null);   // { text, detail } | null
  const [detayAcik, setDetayAcik] = useState(false);
  const [success, setSuccess] = useState('');
  const inputRef              = useRef(null);
  usePencereKapat(onClose);

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setLoading(true); setError(null); setDetayAcik(false); setSuccess('');
    try {
      // PDF'i base64'e cevir
      const arrayBuffer = await file.arrayBuffer();
      const bytes = new Uint8Array(arrayBuffer);
      let binary = '';
      for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
      const pdf_base64 = btoa(binary);

      // JWT al
      const { data: { session } } = await supabase.auth.getSession();
      // Oturum yoksa istegi HIC gondermeyiz; ayni sinifa dusen metin cikar.
      if (!session) { setError(uploadErrorMessage({ status: 401, serverError: 'no local session' })); setLoading(false); return; }

      // Edge Function'a gonder (sunucuda parse + plans/plan_versions yazma)
      const res = await fetch(`${process.env.REACT_APP_SUPABASE_URL}/functions/v1/parse-plan`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${session.access_token}` },
        body: JSON.stringify({ filename: file.name, pdf_base64 }),
      });
      const result = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(uploadErrorMessage({ status: res.status, serverError: result.error }));
        setLoading(false); return;
      }

      // PDF dosyasini Storage'a yukle (her created plan icin)
      // Not: parse-plan plan.id dondurmuyor su an; storage'i ayri ele alacagiz.
      const summary = (result.results || []).map(r => `${r.dep} → ${r.dest}${r.status && r.status.startsWith('updated') ? ' ('+r.status+')' : ''}`).join(', ');
      setSuccess(`${result.count} sector(s): ${summary}`);
      onUploaded();
    } catch (err) {
      // Buraya AG hatasi ve beklenmeyen istisna duser. Ham metin konsolda ve
      // "technical detail"de kalir; ekranda ne yapmasi gerektigi yazar.
      console.error('[UPLOAD] FAILED:', err);
      setError(uploadErrorMessage({ networkError: err }));
    }
    setLoading(false);
  };

  return (
    <div style={{ position:'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.75)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:100 }}>
      <div style={{ background:'var(--bg2)', border:'1px solid var(--border)', borderRadius:12, width:340, overflow:'hidden' }}>
        <div style={{ background:'var(--bg3)', padding:'10px 16px', borderBottom:'1px solid var(--border)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span style={{ fontSize:12, fontWeight:700, color:'var(--accent)' }}>Upload Flight Plan (PDF)</span>
          <KapatX onClose={onClose} />
        </div>
        <div style={{ padding:'20px 16px' }}>
          {!success && (
            <div onClick={() => inputRef.current.click()} style={{ border:'2px dashed var(--border)', borderRadius:10, padding:'32px 20px', display:'flex', flexDirection:'column', alignItems:'center', gap:12, cursor:'pointer' }}>
              <div style={{ fontSize:36 }}>📄</div>
              <div style={{ fontSize:13, color:'var(--t3)', textAlign:'center' }}>Tap to select PDF<br /><span style={{ fontSize:11, color:'var(--t3)' }}>Flight Briefing Package</span></div>
            </div>
          )}
          <input ref={inputRef} data-testid="upload-file-input" type="file" accept=".pdf,application/pdf" onChange={handleFile} style={{ display:'none' }} />
          {loading && <div style={{ marginTop:12, padding:'10px 12px', borderRadius:6, background:'var(--accent-soft)', borderLeft:'3px solid var(--accent)', fontSize:11, color:'var(--accent)' }}>⏳ Reading PDF...</div>}
          {error   && (
            <div style={{ marginTop:12, padding:'10px 12px', borderRadius:6, background:'var(--red-soft)', borderLeft:'3px solid var(--red)', fontSize:11, color:'var(--red)' }}>
              <div style={{ lineHeight:1.5 }}>⚠ {error.text}</div>
              {/* HAM METIN EKRANDA DEGIL — istenirse acilir, kopyalanabilir. */}
              {/* Görünüm düğmesi (5 Eki 2026, tasarım B) — eskiden 9 px soluk yazı. */}
              <GosterGizle acik={detayAcik} onClick={() => setDetayAcik(v => !v)} testid="upload-error-detail-toggle"
                           gizle="HIDE TECHNICAL DETAIL" goster="TECHNICAL DETAIL" style={{ marginTop:8 }} />
              {detayAcik && (
                <div data-testid="upload-error-detail"
                     style={{ marginTop:4, fontFamily:'var(--mono)', fontSize:10, color:'var(--t3)', wordBreak:'break-all', userSelect:'text' }}>
                  {error.detail}
                </div>
              )}
            </div>
          )}
          {success && <div style={{ marginTop:12, padding:'10px 12px', borderRadius:6, background:'var(--green-soft)', borderLeft:'3px solid var(--green)', fontSize:11, color:'var(--green)' }}>✓ {success}</div>}
        </div>
        <div style={{ padding:'0 16px 16px' }}>
          <button onClick={onClose} style={{ width:'100%', background:'var(--border)', border:'1px solid var(--border)', borderRadius:7, padding:10, fontSize:13, color:'var(--t3)', cursor:'pointer', fontFamily:'inherit' }}>
            {success ? 'Close' : 'Cancel'}
          </button>
        </div>
      </div>
    </div>
  );
}


export default UploadPlanModal;
